type StarRatingProps = {
  rating: number;   // e.g. 3.5
  max?: number;     // default 5
  size?: number;    // px
  emptyColor?: string;
  fullColor?: string;
};

const getStars = (rating: number, max: number): string[] => {
  const stars: string[] = [];
  for (let i = 0; i < max; i++) {
    if (rating >= i + 1) {
      stars.push("full");
    } else if (rating > i && rating < i + 1) {
      stars.push("half");
    } else {
      stars.push("empty");
    }
  }
  return stars;
};

const RatingStars = ({
  rating,
  max = 5,
  size = 18,
  fullColor,
  emptyColor,
}: StarRatingProps) => {
  const stars = getStars(rating, max);

  return (
    <div
      aria-label={`Rating: ${rating} out of ${max}`}
      style={{ display: "flex", gap: 4 }}
    >
      {stars.map((type, index) => (
        <span
          key={index}
          style={{
            fontSize: size,
            color: type === "empty" ? emptyColor : fullColor,
          }}
        >
          {type === "full" && "★"}
          {type === "half" && "⯪"} {/* optional half symbol */}
          {type === "empty" && "☆"}
        </span>
      ))}
    </div>
  );
}

export default RatingStars;